
import { Avatar, Checkbox, TableCell, TableRow, Typography } from "@mui/material";
import { separadorMillares, usePrecioCarritoXRole } from "../../../hooks";
const baseUrl = process.env.REACT_APP_API_URL;





export const TablaCotizacionSinEditar = ({ data, selected, handleClick }) => {


    const { precioUnidadSegunRol } = usePrecioCarritoXRole();
    


    return (
        <>
        {data?.map( car => (
            <TableRow key={ car.id } onClick={ () => handleClick(car.id)}>
                <TableCell padding="checkbox">
                    <Checkbox 
                        color="primary" 
                        checked={selected.some( (item) => item === car.id )} 
                    />
                </TableCell>

                <TableCell sx={{ display:'flex', justifyContent:'center' }}>
                    <Avatar
                        alt="Imagen de Producto"
                        src={`${ baseUrl }/uploads/productos/${ car.producto.img }`} 
                        sx={{ width: 50, height: 50 }}
                    /> 
                </TableCell>

                <TableCell className="w-300">{ car.producto.nombre }</TableCell>
                <TableCell>{ car.cantidad }</TableCell>
                <TableCell>{`$${separadorMillares(precioUnidadSegunRol(car) / car.cantidad)}`}</TableCell>
                <TableCell>{`$${separadorMillares(precioUnidadSegunRol(car))}`}</TableCell>
            </TableRow>
        ))}

        <TableRow >
            <TableCell colSpan="5">
                <Typography sx={{display:'flex', justifyContent:"flex-start"}} variant="span">
                    Todos los valores descritos en esta cotización estan antes de IVA.
                </Typography>
            </TableCell>
        </TableRow>
        </>

    )
}
